/* eslint-disable indent */
import React from 'react'
import { Card, Form, Row, Col, Button } from 'react-bootstrap'
import { skillArr, translations } from '../services/arrays'
import { getTranslation } from '../services/translations'

const TargetSkillsCard = ({
  player,
  targetSkills,
  handleTargetSkillChange,
  handleAddTargetSkill,
  handleSubmitTrainingPlan,
  handleDeleteTrainingPlan,
  trainingPlan,
  completedWeeks,
  selectedOptimizePosition,
  setSelectedOptimizePosition,
  optimizePositions,
  handleOptimizeSkills,
  language,
  lang,
}) => {
  const t = key => getTranslation(lang, key)

  return (
    <Card
      className="flex-fill"
      style={{
        backgroundColor: '#2C2F33',
        color: '#FFFFFF',
        borderColor: '#1E2124',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('targetSkillsEntry')}
      </Card.Header>
      <Card.Body>
        {targetSkills.map((targetSkill, index) => (
          <Row key={index} className="mb-2">
            <Col xs={6}>
              <Form.Control
                as="select"
                value={targetSkill.skill}
                onChange={e =>
                  handleTargetSkillChange(index, 'skill', e.target.value)
                }
                style={{
                  backgroundColor: '#23272A',
                  color: '#FFFFFF',
                  fontSize: '12px',
                  padding: '3px',
                }}
              >
                <option value="">{t('selectSkill')}</option>
                {skillArr.map(skill => (
                  <option key={skill} value={skill}>
                    {translations[skill][language]}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col xs={6}>
              <Form.Control
                type="number"
                placeholder={t('targetLevel')}
                value={targetSkill.target}
                onChange={e =>
                  handleTargetSkillChange(index, 'target', e.target.value)
                }
                style={{
                  backgroundColor: '#23272A',
                  color: '#FFFFFF',
                  fontSize: '12px',
                  padding: '3px',
                }}
              />
            </Col>
          </Row>
        ))}
        <div className="d-flex flex-column">
          <Button onClick={handleAddTargetSkill} className="mt-2" size="sm">
            {t('addTargetSkill')}
          </Button>
          <Button
            onClick={handleSubmitTrainingPlan}
            variant="success"
            className="mt-2"
            size="sm"
          >
            {t('calculatePlan')}
          </Button>
          {player.scoutTrainingPlan ? (
            <Button
              onClick={handleDeleteTrainingPlan}
              variant="warning"
              className="mt-2"
              size="sm"
            >
              {t('deletePlan')}
            </Button>
          ) : (
            <></>
          )}
        </div>

        {/* Show training plan */}
        {trainingPlan && trainingPlan.finalLevels && trainingPlan.skillWeeks ? (
          <div className="mt-4" style={{ fontSize: '0.875rem' }}>
            <h6 className="text-sm">{t('trainingPlan')}</h6>
            <Row className="text-sm">
              <Col md={5}>
                <strong>{t('skill')}</strong>
              </Col>
              <Col>
                <strong>{t('weeks')}</strong>
              </Col>
              <Col>
                <strong>{t('skillLevel')}</strong>
              </Col>
            </Row>
            {trainingPlan.finalLevels.map((level, index) => {
              const plannedWeeks = trainingPlan.skillWeeks[index].weeks
              const done = completedWeeks[level.skill] || 0
              const remaining = plannedWeeks - done
              if (remaining === 0) return null
              return (
                <Row key={index} className="text-sm">
                  <Col md={5}>
                    {translations[level.skill]
                      ? translations[level.skill][language]
                      : level.skill.replace('Skill', '')}
                  </Col>
                  <Col>
                    <span
                      style={{
                        color: remaining < 0 ? '#e74c3c' : 'inherit',
                      }}
                    >
                      {remaining}
                    </span>
                    {done > 0 && (
                      <small style={{ color: '#888', marginLeft: '4px' }}>
                        ({plannedWeeks}−{done})
                      </small>
                    )}
                  </Col>
                  <Col>
                    {level.finalLevel !== null && level.finalLevel !== undefined
                      ? level.finalLevel.toFixed(3)
                      : '-'}
                  </Col>
                </Row>
              )
            })}
            <div className="mt-3 text-sm">
              <p>
                {t('age')}: {trainingPlan.finalAge[0]}.
                {trainingPlan.finalAge[1]} <br />
                {(() => {
                  const totalDone = Object.values(completedWeeks).reduce(
                    (sum, v) => sum + v,
                    0
                  )
                  const totalRemaining = trainingPlan.totalWeeks - totalDone
                  return (
                    <>
                      {t('weeks')}: {totalRemaining}
                      {totalDone > 0 && (
                        <small style={{ color: '#888', marginLeft: '4px' }}>
                          ({trainingPlan.totalWeeks}−{totalDone})
                        </small>
                      )}
                    </>
                  )
                })()}
              </p>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* Optimoi taidot */}
        <hr style={{ borderColor: '#444' }} />
        <div className="mt-3">
          <Form.Label>{t('positionForOptimization')}:</Form.Label>
          <Row className="g-2 align-items-center">
            <Col xs={6}>
              <Form.Select
                value={selectedOptimizePosition}
                onChange={e => setSelectedOptimizePosition(e.target.value)}
                style={{
                  backgroundColor: '#23272A',
                  color: '#FFFFFF',
                  fontSize: '12px',
                }}
              >
                {optimizePositions.map(pos => (
                  <option key={pos} value={pos}>
                    {pos}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xs={6}>
              <Button
                variant="info"
                size="sm"
                onClick={handleOptimizeSkills}
                style={{ width: '100%' }}
              >
                {t('optimizeSkills')}
              </Button>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  )
}

export default TargetSkillsCard
